import React from 'react';
import { SearchInput, TopToolbar, ReferenceInput, SelectInput, useTranslate } from 'react-admin';

const FILTER_CONTROL_SX = {
  minWidth: { xs: '100%', sm: 220 },
  maxWidth: { sm: 320 },
  '& .MuiFilledInput-root, & .MuiOutlinedInput-root, & .MuiInputBase-root': {
    borderRadius: '10px',
    backgroundColor: '#fff',
  },
  '& .MuiInputBase-input': {
    fontSize: 14,
    py: '10px',
  },
  '& .MuiInputLabel-root': {
    fontSize: 13,
    fontWeight: 600,
  },
};

const SELECT_CONTROL_SX = {
  ...FILTER_CONTROL_SX,
  minWidth: { xs: '100%', sm: 180 },
  maxWidth: { sm: 240 },
};

/** Ortak arama kutusu — başvurular vb. (SearchInput label kabul etmez). */
export const ListSearchInput = ({ source = 'q', placeholder, label: _label, ...rest }) => {
  const translate = useTranslate();
  return (
    <SearchInput
      source={source}
      alwaysOn
      resettable
      variant="outlined"
      placeholder={
        placeholder ||
        translate('form.search_placeholder', {
          _: 'Ad, e-posta, telefon…',
        })
      }
      sx={FILTER_CONTROL_SX}
      {...rest}
    />
  );
};

/** Mekan listesi — şehir/kategori (serbest arama ListQSearchBar ile). */
export const getVenueListFilters = (localeNameKey) => [
  <ReferenceInput source="city" reference="cities" key="city" alwaysOn>
    <SelectInput
      optionText={localeNameKey}
      label="Şehir"
      emptyText="Tümü"
      resettable
      variant="outlined"
      sx={SELECT_CONTROL_SX}
    />
  </ReferenceInput>,
  <ReferenceInput source="category" reference="venueCategories" key="category" alwaysOn>
    <SelectInput
      optionText={localeNameKey}
      label="Kategori"
      emptyText="Tümü"
      resettable
      variant="outlined"
      sx={SELECT_CONTROL_SX}
    />
  </ReferenceInput>,
];

/** Org şirket listesi — şehir (serbest arama ListQSearchBar ile). */
export const getOrganisationListFilters = (localeNameKey) => [
  <ReferenceInput source="city" reference="cities" key="city" alwaysOn>
    <SelectInput
      optionText={localeNameKey}
      label="Şehir"
      emptyText="Tümü"
      resettable
      variant="outlined"
      sx={SELECT_CONTROL_SX}
    />
  </ReferenceInput>,
];

/** Affiliate listesi — serbest arama ListQSearchBar ile. */
export const getAffiliateListFilters = () => [];

/** Sale agents listesi — serbest arama ListQSearchBar ile. */
export const getSaleAgentListFilters = () => [];

/** Applications — venue. */
export const VENUE_APPLICATION_FILTERS = [
  <ListSearchInput key="venue-app-q" placeholder="Ad, e-posta, telefon…" />,
];

/** Applications — organisation. */
export const ORGANISATION_APPLICATION_FILTERS = [
  <ListSearchInput key="org-app-q" placeholder="Ad, e-posta, telefon…" />,
];

/** Applications — sale agents / affiliate. */
export const SALE_AGENT_APPLICATION_FILTERS = [
  <ListSearchInput key="sa-app-q" placeholder="Ad, e-posta, telefon…" />,
];

/** @deprecated use SALE_AGENT_APPLICATION_FILTERS */
export const AFFILIATE_APPLICATION_FILTERS = SALE_AGENT_APPLICATION_FILTERS;

/** Toolbar yüksekliğini korur; içerik gizli (sekme geçişinde zıplama olmasın). */
export const TabbedListActionsPlaceholder = () => (
  <TopToolbar
    sx={{
      minHeight: 48,
      visibility: 'hidden',
      pointerEvents: 'none',
    }}
  >
    &nbsp;
  </TopToolbar>
);

export const TABBED_LIST_SX = {
  '& .RaListToolbar-root': {
    minHeight: 64,
    alignItems: 'center',
    gap: 1,
    flexWrap: 'wrap',
    px: { xs: 1, sm: 0 },
  },
  '& .RaList-actions': {
    minHeight: '48px !important',
  },
  '& .RaFilterForm-root': {
    minHeight: 64,
    boxSizing: 'border-box',
    alignItems: 'center',
    gap: 1.5,
    flexWrap: 'wrap',
    width: '100%',
  },
  '& .RaFilterFormInput-spacer': {
    display: 'none',
  },
  '& .RaFilterFormInput-root': {
    alignItems: 'center',
    margin: '0 !important',
  },
  '& .filter-field': {
    margin: 0,
  },
};

/**
 * Yaklaşan etkinlikler (MUI DataGrid) gibi: kolonlar sıkışmaz, dar ekranda yatay scroll.
 */
export const SCROLLABLE_DATAGRID_SX = {
  width: '100%',
  overflowX: 'auto',
  '& .RaDatagrid-tableWrapper': {
    overflowX: 'auto',
    width: '100%',
  },
  '& table': {
    width: 'max-content',
    minWidth: '100%',
  },
  '& .MuiTableCell-root': {
    whiteSpace: 'nowrap',
  },
};
